var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapePmmQ(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 312.4603574601242 85.97697922515499",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-left-left-button-1",
    opacity: 1,
    fillRule: "evenodd",
    d: "M46.999999999999766,14.5 L0,62.5 L10.999999999999773,85.97697922515499 L302.4603574601234,85.97697922515499 L312.4603574601232,74.5 L312.4603574601234,0 "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-2",
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "rgb(0,187,255)",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "rgb(0,187,255)",
    stopOpacity: 0.1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-left-left-button-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapePmmQ);
export default __webpack_public_path__ + "static/media/shape-pmm-q.39b7374ab7c7deafe419ffd78b1150fc.svg";
export { ForwardRef as ReactComponent };